import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Typography,
  TableCell,
  Modal,
  TextField,
  InputLabel,
  Grid,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useParams } from "react-router-dom";

import { RiDeleteBin6Line } from "react-icons/ri";
import Title from "../Dashboard/Title";
import LoaderLine from "../LoaderLine";
import {
  useAddTutorialFileMutation,
  useGetAllTutorialUploadedFilesQuery,
  useDeleteTutorialAddedFilesMutation,
} from "../../api";
import { toast } from "react-toastify";
import FormLoader from "../FormLoader";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "rgba(103, 30, 120, 0.1)",
    fontFamily: "Gilroy-Bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Gilroy-Regular",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: " rgba(103, 30, 120, 0.1)",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const Tutorial_Second = () => {

  const { id } = useParams();
  const naviagte = useNavigate();
  const [openEdit, setOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [questionId, setQuestionId] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [description, setDescription] = useState();
  const [fileId, setFIleId] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const { data, isLoading, refetch } = useGetAllTutorialUploadedFilesQuery({
    tutorialId: id,
  });

  const [onAddTutorialFile] = useAddTutorialFileMutation();

  const handleUploadFile = async () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("fileName", "string");
    formData.append("tutoriaId", id);
    formData.append("fileDescription", description);

    if (selectedFile instanceof File) {
      formData.append("attchedFileContent", selectedFile);
    }

    try {
      const res = await onAddTutorialFile(formData)?.unwrap();
      if (res) {
        toast.success(res?.message);
        setDescription("");
        setSelectedFileName("");
      }
    } catch (err) {
      toast.error("There was an error uploading questions");
    } finally {
      setLoading(false);
    }
  };
  
  const handleGoBack = () => {
    naviagte(-1)
  }
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setSelectedFileName(file.name)
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const idP = open ? "simple-popover" : undefined;
  const [onDeleteFile] = useDeleteTutorialAddedFilesMutation();

  const deleteTutorialFile = async () => {
    setLoading(true);
    try {
      const res = await onDeleteFile({
        fileId: fileId,
      }).unwrap();
      if (res) {
        setLoading(false);
        setOpenDelete(false);
        setAnchorEl(null);
        refetch();
        toast.success(res.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error("there was an error", error);
    }
  };

  function truncateString(str, maxLength) {
    if (str?.length <= maxLength) {
      return str;
    }

    return str.slice(0, maxLength) + "...";
  }

  return (
    <>
      {loading || (isLoading && <LoaderLine />)}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title title="Tutorial/Resources - Add Files" />
      </Box>
      <Box
        sx={{
          mt: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div onClick={handleGoBack} className="cursor-pointer">
          <IconButton
            sx={{
              bgcolor: "#671e781a",
              width: "30px",
              height: "30px",
              mr: 2,
            }}
          >
            <KeyboardBackspaceIcon />
          </IconButton>
        </div>
        <Box>
          <Typography variant="caption" sx={{ fontFamily: "gilroy-regular" }}>
            Back to Tutorial
          </Typography>
        </Box>
      </Box>

      <Grid
        sx={{
          bgcolor: "#671e781a",
          padding: "40px",
          borderRadius: "20px",
        }}
        item
        lg={12}
        xs={12}
      >
        <Box>
          <InputLabel
            sx={{
              mb: 1.5,
              mt: 1,
              fontSize: "12px",
              fontWeight: "bolder",
              color: "#000",
              fontFamily: "Gilroy-Medium",
            }}
          >
            Description
          </InputLabel>
          <TextField
            fullWidth
            multiline
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid #671E78",
                },
              },
            }}
            InputProps={{
              style: {
                fontFamily: "Gilroy-regular",
                fontSize: "13px",
              },
            }}
          />
        </Box>
        <Grid item lg={12} xs={12}>
          <InputLabel
            sx={{
              fontFamily: "gilroy-regular",
              color: "#333",
              fontSize: "12px",
              mb: 1,
              mt: 3,
            }}
          >
            Upload File (optional)
          </InputLabel>
          <TextField
            type="file"
            fullWidth
            onChange={handleFileChange}
            InputProps={{
              style: {
                fontFamily: "Gilroy-regular",
                fontSize: "13px",
                borderRadius: "5px",
                offset: " 0.5px solid #671E78",
                border: " 0.5px solid #671E78",
              },
            }}
          />
        </Grid>
        <Box sx={{ mt: 3 }}>
          <Button
            disabled={!selectedFileName || !description || loading}
            variant="contained"
            fullWidth
            component="label"
            sx={{ textTransform: "initial" }}
            onClick={handleUploadFile}
          >
            {loading ? <FormLoader /> : <span>Add File</span>}
          </Button>
        </Box>
      </Grid>
      <Box sx={{ mt: 5 }}>
        <Typography
          sx={{
            fontFamily: "Gilroy-Bold",
            mb: 2,
          }}
        >
          Uploaded Files
        </Typography>

        <TableContainer
          sx={{
            borderRadius: "12px",
            border: "1px solid #eee",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>S/N</StyledTableCell>
                <StyledTableCell>File Name</StyledTableCell>
                <StyledTableCell>Upload Date</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.data?.length > 0 ? (
                data?.data?.map((file, index) => (
                  <StyledTableRow key={file.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>

                    <StyledTableCell>
                      {truncateString(file.fileDescription, 40)}
                    </StyledTableCell>

                    <StyledTableCell>
                      {new Date(file.uploadDate).toLocaleDateString()}
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                        {/* Preview */}
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => setPreviewUrl(file.attchedFileUrl)}
                        >
                          View
                        </Button>

                        {/* Delete */}
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setFIleId(file.id);
                            setQuestionId(file.id);
                            handleOpenDelete();
                          }}
                        >
                          Delete
                        </Button>
                      </Box>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={4} align="center">
                    No files uploaded yet
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Modal
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDelete}>
          <Box align="center">
            <RiDeleteBin6Line style={{ fontSize: "42px", color: "#d3302f" }} />
            <Box sx={{ mt: 3 }}>
              <Typography sx={{ fontFamily: "gilroy-bold" }}>
                You're about to delete this file
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: "gilroy-regular",
                color: "#9c9c9c",
                fontSize: "12px",
              }}
            >
              This will delete the file from the database
            </Typography>
            <Typography
              sx={{
                fontFamily: "gilroy-regular",
                color: "#9c9c9c",
                fontSize: "12px",
                mt: 2,
              }}
            >
              Are you sure?
            </Typography>
          </Box>
          <Box align="right" sx={{ mt: 2 }}>
            <Button
              sx={{
                color: "#333",
                textTransform: "initial",
                fontFamily: "gilroy-regular",
              }}
              onClick={handleCloseDelete}
            >
              Cancel
            </Button>
            <Button
              onClick={deleteTutorialFile}
              sx={{
                bgcolor: "#d3302f",
                color: "#fff",
                ml: 2,
                px: 3,
                textTransform: "initial",
                fontFamily: "gilroy-regular",
                "&:hover": {
                  bgcolor: "#d3302fb7",
                  color: "#fff",
                },
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* preview */}
      <Modal
        open={Boolean(previewUrl)}
        onClose={() => setPreviewUrl(null)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            bgcolor: "#fff",
            p: 2,
          }}
        >
          <iframe
            src={previewUrl}
            width="100%"
            height="100%"
            title="PDF Preview"
          />
        </Box>
      </Modal>
    </>
  );
};